import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-charts/themeAugmentation';

import { capitalCategoricalPalette } from '../../capitalCategoricalPalette';

export const MuiLineChart: ThemeOptions['components']['MuiLineChart'] = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
